<template>
  <div data-slot="default" :id="`step-manager-${stepManagerId}`">
    <div>

      <slot>

        <div>

          <m-step-manager-step-1>
            <h1>hello</h1>
          </m-step-manager-step-1>

          <m-step-manager-step-1>
            <h1>world</h1>
          </m-step-manager-step-1>

        </div>

      </slot>

    </div>

    <div class="text-center my-3">
      <button v-if="isPrevStepActive" class="btn btn-primary mx-2 rounded-pill" @click="prevStepWrapper()">
        {{ buttonTranslation.previous_button }}
      </button>
      <button v-if="isLastStep" class="btn btn-primary mx-2 rounded-pill" @click="stepManagerSubmitMethod">
        {{ buttonTranslation.submit_button }}
      </button>
      <button v-if="isNextStepActive" class="btn btn-primary mx-2 rounded-pill" @click="nextStepWrapper()">
        {{ buttonTranslation.next_button }}
      </button>
    </div>

  </div>
</template>

<script>
import {generateRandomString} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import mStepManagerStep1 from "./Step/StepManagerStep1.vue";

export default {
  name: "StepManager",
  components: {mStepManagerStep1},
  props: {
    form: {},
    stepsConfig: {
      type: Array,
      default: () => [],
    },
    stepManagerSubmitMethod: {},
    formValidation: {}
  },
  data() {
    return {
      currentStep: 0,
      steps: [],
      currentStepObject: null,
      stepManagerId: generateRandomString()
    };
  },
  computed: {
    isNextStepActive() {
      return this.currentStep < this.steps.length - 1
    },
    isPrevStepActive() {
      return this.currentStep > 0
    },
    isLastStep() {
      return this.currentStep === this.steps.length - 1
    },
    formType() {
      return this.form.formType
    },
    buttonTranslation() {
      let buttonText = {
        next_button: 'next',
        previous_button: 'previous',
        submit_button: 'submit',
      }

      if (this.formType == 'product') {
        buttonText = {
          next_button: this.$t('product.step_manager.next_button'),
          previous_button: this.$t('product.step_manager.previous_button'),
          submit_button: this.$t('product.step_manager.submit_button'),
        }
      }

      return buttonText
    },
  },
  methods: {
    initComponent() {
      try {
        this.steps = document.querySelectorAll(`#step-manager-${this.stepManagerId} [data-step]`)
        this.currentStepObject = this.steps[this.currentStep]
      } catch (e) {
        console.log(e)
      }
    },
    async showStepComponents() {
      this.initComponent()
      this.steps.forEach(item => {
        item.classList.add('d-none');
      })
      if (this.currentStepObject) {
        this.currentStepObject.classList.remove('d-none');
      }

    },
    async nextStep() {
      if (this.isNextStepActive) {
        this.currentStep += 1;
        await this.showStepComponents()
      }
    },
    nextStepWrapper() {
      this.nextStep()
    },
    async prevStep() {
      if (this.isPrevStepActive) {
        this.currentStep -= 1;
        await this.showStepComponents()

      }
    },
    prevStepWrapper() {
      this.prevStep()
    },

  },
  async mounted() {
    this.initComponent()
    await this.showStepComponents()
  }
};
</script>
